<div class="patient-banner" [ngClass]="{ 'fix-banner': isLIC }" *ngIf="appointment">
    <div class="info-section text-capitalize">
        <div class="left-section">
            <button type="button" class="no-button" (click)="gotoBrowser()" *ngIf="isLIC">
                <mat-icon class="settings-icon" fontIcon="settings"
                     matTooltip="Settings" cvaAuthPermCheck
                    [moduleName]="CVA_AUTH_MODULES.CVA_SOAP_NOTES" [permissionType]="CVA_CONSTANTS.PERMISSION.WRITE"
                    [actionType]="'disable'" ></mat-icon>
            </button>
            <div class="patient-info">
                <div class="patientName">{{ appointment.patient.firstName }} {{ appointment.patient.lastName }}</div>
                <div class="info-container">
                    <div class="info-label">Gender:</div>
                    <div class="info-value">{{ genderAbbr }}</div>
                    <div class="info-label">Age:</div>
                    <div class="info-value rightMargin text-truncate age-text">{{ appointment.patient.dateOfBirth | age
                        }}</div>
                </div>
            </div>
        </div>
        <div class="right-section">
            <img *ngIf="isLIC" [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="CVA logo" width="70px" />
            <div *ngIf="!isLIC">
                <div class="info-label">Visit Type</div>
                <div class="info-value rightMargin text-truncate visit-type-text">{{ appointment.appointmentType }}
                </div>
            </div>
            <div *ngIf="!isLIC">
                <div class="info-label">Date</div>
                <div class="info-value date-text">{{ appointment.start | date:'EEE dd MMM, yyyy' }}</div>
            </div>
        </div>
    </div>
</div>